var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isPublic)?_c('pub'):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }